import { useMemo, useState, useCallback } from "react";
import ProjectBar from "./components/project-bar.jsx";
import RapidoDocView from "./components/rapido-doc-view.jsx";

const API_ARCHIVER = import.meta.env.VITE_API_ARCHIVER;
const DESPACHO_URL = import.meta.env.VITE_API_DESPACHO;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export default function Documentation() {
    const projects = useMemo(() => [
        { key: "keeper", label: "Keeper", specUrl: `${API_KEEPER}/v3/api-docs` },
        { key: "archiver", label: "Archiver", specUrl: `${API_ARCHIVER}/api/api-docs` },
        { key: "despacho", label: "Despacho", specUrl: `${DESPACHO_URL}/v3/api-docs` },
    ]);

    const [selectedKey, setSelectedKey] = useState("keeper");
    const [modeKey, setModeKey] = useState("light");

    const toggleMode = () => setModeKey((m) => (m === "dark" ? "light" : "dark"));

    const selectedProject = useMemo(
        () => projects.find((p) => p.key === selectedKey) ?? projects[0],
        [projects, selectedKey]
    );
    const copyToClipboard = useCallback((text) => {
        navigator.clipboard.writeText(text);
    }, []);

    return (
        <div className="h-screen flex flex-col">
            <div className="flex-1 min-h-0">
                <RapidoDocView
                    key={selectedProject?.key}
                    specUrl={selectedProject?.specUrl}
                    modeKey={modeKey}
                    copyToClipboard={copyToClipboard}
                >
                    <ProjectBar
                        projects={projects}
                        selectedKey={selectedKey}
                        onChangeProject={setSelectedKey}
                        modeKey={modeKey}
                        onToggleMode={toggleMode}
                    />
                </RapidoDocView>
            </div>
        </div>
    );
}